import {createApiClient} from "./index";
import {generateQueryParams} from "helpers/common";
import {SlackDto, SlackQueryParams} from "types/slack";

export const slackApi = {
    async getSlack({
                       filters,
                       token,
                       params,
                       apiKey
                   }: SlackQueryParams, signal?: AbortSignal): Promise<SlackDto> {
        const api = createApiClient(apiKey);

        const data = Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => !!value || value === 0)
        );

        const queryParams = generateQueryParams(params);

        const response = await api.post(`/slack/filter${queryParams}`, {
            ...data,

        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal,
        });
        return response.data;
    },
};
